import { CognitoUserPool, CognitoUser } from "amazon-cognito-identity-js";

type ApiGateway = {
  user_pool_id?: string;
  app_client_id?: string;
};

const recoverService = {
  async forgotPassword(email: string, apiGateway: ApiGateway): Promise<{ status: "Success" | "Failure"; error?: string }> {
    const poolData = {
        UserPoolId: "us-east-1_af2GRumEQ",
        ClientId: "28qrq8nr4tih8odvf11ufs1a9s",
    };
    const userPool = new CognitoUserPool(poolData);
    const userData = {
      Username: email.toLowerCase(),
      Pool: userPool,
    };

    const cognitoUser = new CognitoUser(userData);

    return new Promise((resolve) => {
      cognitoUser.forgotPassword({
        onSuccess: () => {
          resolve({ status: "Success" });
        },
        onFailure: (err) => {
          resolve({ status: "Failure", error: err.message });
        },
      });
    });
  },

  async confirmPasswordReset(
    verificationCode: string,
    newPassword: string,
    email: string,
    apiGateway: ApiGateway
  ): Promise<{ status: "Success" | "Failure"; error?: string }> {
    const poolData = {
      UserPoolId: apiGateway.user_pool_id ?? "",
      ClientId: apiGateway.app_client_id ?? "",
    };
    const userPool = new CognitoUserPool(poolData);
    const userData = {
      Username: email.toLowerCase(),
      Pool: userPool,
    };

    const cognitoUser = new CognitoUser(userData);

    return new Promise((resolve) => {
      cognitoUser.confirmPassword(verificationCode, newPassword, {
        onSuccess: () => {
          resolve({ status: "Success" });
        },
        onFailure: (err) => {
          resolve({ status: "Failure", error: err.message });
        },
      });
    });
  },
};

export default recoverService;